<div class="rgb-named-color-picker-block d-flex justify-content-space-between text-align-center">
	<!-- Color picker component -->
	<ng-rgb-color-picker
		#rgbColorPicker
		[(ngModel)]="newColor"
		(ngModelChange)="onPickerColorChange($event)"
	></ng-rgb-color-picker>

	<!-- Input field with color name and hexCode -->
	<div class="form-group align-self-center color-name-wrapper">
		<div
			ngbDropdown
			class="d-inline-block m-0 colors-ngb-dropdown"
			container="body"
		>
			<!-- Open dropdown menu button -->
			<button
				type="button"
				class="form-control colors-dropdown-btn position-relative text-truncate"
				id="colorsDropdownMenuBtn"
				data-toggle="dropdown"
				ngbDropdownToggle
			>
				<div
					*ngIf="colorData"
					class="text-truncate color-name-container-width"
					ngTooltip="{{ colorData.hexCode }}"
					container="body"
					onlyTruncate
					[class.light-text]="isDarkMode"
				>
					{{ colorData.name }}
					<span
						*ngIf="colorData.hexCode"
						class="ms-1"
					>
						( {{ colorData.hexCode }} )
					</span>
				</div>
				<span
					class="position-absolute dropdown-arrow"
					data-toggle="dropdown"
				>
					<ng-fa-icon
						icon="chevron-down"
						[fixedWidth]="false"
					></ng-fa-icon>
				</span>
			</button>

			<!-- Dropdown menu -->
			<div
				class="colors-dropdown-menu scroll-bar"
				ngbDropdownMenu
				aria-labelledby="colorsDropdownMenuBtn"
			>
				<!-- New color -->
				<button
					ngbDropdownItem
					*ngIf="colorData?.hexCode && !colorData.isPredefinedColor"
					class="color-item ps-2 ignore-dark-mode"
					[class.light-text]="isDarkMode"
					[class.active]="colorData.isCurrentlySelected"
				>
					<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
					<span
						class="color-icon-spacing ms-2 me-1"
						[style.color]="colorData.hexCode"
					>
						<ng-fa-icon
							icon="droplet"
							[fixedWidth]="false"
						></ng-fa-icon>
					</span>
					{{ colorData.name }}
				</button>

				<!-- Line separator -->
				<div
					class="dropdown-divider"
					*ngIf="colorData?.hexCode && !colorData.isPredefinedColor && predefinedColorsList.length > 0"
				></div>

				<!-- Predefined colors -->
				<div *ngIf="predefinedColorsList">
					<button
						ngbDropdownItem
						class="color-item ps-2 ignore-dark-mode"
						*ngFor="let predefinedColor of predefinedColorsList"
						[class.light-text]="isDarkMode"
						(click)="applyColor(predefinedColor.hexCode)"
						[class.active]="predefinedColor.isCurrentlySelected"
						[value]="predefinedColor.hexCode"
						(mouseover)="onMouseOver(predefinedColor.hexCode)"
						(mouseout)="onMouseOut(value)"
					>
						<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
						<span
							class="color-icon-spacing pointer-events-none ms-2 me-1"
							[style.color]="predefinedColor.hexCode"
						>
							<ng-fa-icon
								icon="droplet"
								[fixedWidth]="false"
							></ng-fa-icon>
						</span>
						{{ predefinedColor.name | titlecase }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Reset color -->
	<div class="clear-color align-self-center">
		<span
			ngTooltip="Reset Background"
			role="button"
			(click)="onResetColor()"
		>
			<ng-fa-icon
				icon="rotate-left"
				[fixedWidth]="false"
			></ng-fa-icon>
		</span>
	</div>
</div>
